// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreeItem_Wrapper__Zc9Z2 {
	list-style: none;
	box-sizing: border-box;
	padding-left: var(--spacing);
	margin-bottom: -1px;

	&.TreeItem_clone__hwBk- {
		display: inline-block;
		pointer-events: none;
		padding: 0;
		padding-left: 10px;
		padding-top: 5px;

		.TreeItem_TreeItem__bBa8K {
			--vertical-padding: 5px;

			padding-right: 24px;
			border-radius: 4px;
			box-shadow: 0px 15px 15px 0 rgba(34, 33, 81, 0.1);
		}
	}

	&.TreeItem_ghost__dhwuH {
		&.TreeItem_indicator__BlfgY {
			opacity: 1;
			position: relative;
			z-index: 1;
			margin-bottom: -1px;

			.TreeItem_TreeItem__bBa8K {
				position: relative;
				padding: 0;
				height: 8px;
				border-color: #2389ff;
				background-color: #56a1f8;

				&:before {
					position: absolute;
					left: -8px;
					top: -4px;
					display: block;
					content: "";
					width: 12px;
					height: 12px;
					border-radius: 50%;
					border: 1px solid #2389ff;
					background-color: #ffffff;
				}

				> * {
					/* Items are hidden using height and opacity to retain focus */
					opacity: 0;
					height: 0;
				}
			}
		}

		&:not(.TreeItem_indicator__BlfgY) {
			opacity: 0.5;
		}

		.TreeItem_TreeItem__bBa8K > * {
			box-shadow: none;
			background-color: transparent;
		}
	}
}

.TreeItem_TreeItem__bBa8K {
	--vertical-padding: 10px;

	position: relative;
	display: flex;
	align-items: center;
	padding: var(--vertical-padding) 10px;
	background-color: #fff;
	border: 1px solid #dedede;
	color: #222;
	box-sizing: border-box;
}

.TreeItem_Text__ejgsU {
	flex-grow: 1;
	padding-left: 0.5rem;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.TreeItem_Count__sHU5v {
	position: absolute;
	top: -10px;
	right: -10px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: #2389ff;
	font-size: 0.8rem;
	font-weight: 600;
	color: #fff;
}

.TreeItem_disableInteraction__0IK4x {
	pointer-events: none;
}

.TreeItem_disableSelection__zicWc,
.TreeItem_clone__hwBk- {
	.TreeItem_Text__ejgsU,
	.TreeItem_Count__sHU5v {
		user-select: none;
		-webkit-user-select: none;
	}
}

.TreeItem_Collapse__wXJRH {
	svg {
		transition: transform 250ms ease;
	}

	&.TreeItem_collapsed__K4TKF svg {
		transform: rotate(-90deg);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/TreeItem/TreeItem.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,4BAA4B;CAC5B,mBAAmB;;CAEnB;EACC,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;;EAEhB;GACC,uBAAuB;;GAEvB,mBAAmB;GACnB,kBAAkB;GAClB,iDAAiD;EAClD;CACD;;CAEA;EACC;GACC,UAAU;GACV,kBAAkB;GAClB,UAAU;GACV,mBAAmB;;GAEnB;IACC,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,yBAAyB;;IAEzB;KACC,kBAAkB;KAClB,UAAU;KACV,SAAS;KACT,cAAc;KACd,WAAW;KACX,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,yBAAyB;KACzB,yBAAyB;IAC1B;;IAEA;KACC,8DAA8D;KAC9D,UAAU;KACV,SAAS;IACV;GACD;EACD;;EAEA;GACC,YAAY;EACb;;EAEA;GACC,gBAAgB;GAChB,6BAA6B;EAC9B;CACD;AACD;;AAEA;CACC,wBAAwB;;CAExB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,qCAAqC;CACrC,sBAAsB;CACtB,yBAAyB;CACzB,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;CAEC;;EAEC,iBAAiB;EACjB,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC,gCAAgC;CACjC;;CAEA;EACC,yBAAyB;CAC1B;AACD","sourcesContent":[".Wrapper {\n\tlist-style: none;\n\tbox-sizing: border-box;\n\tpadding-left: var(--spacing);\n\tmargin-bottom: -1px;\n\n\t&.clone {\n\t\tdisplay: inline-block;\n\t\tpointer-events: none;\n\t\tpadding: 0;\n\t\tpadding-left: 10px;\n\t\tpadding-top: 5px;\n\n\t\t.TreeItem {\n\t\t\t--vertical-padding: 5px;\n\n\t\t\tpadding-right: 24px;\n\t\t\tborder-radius: 4px;\n\t\t\tbox-shadow: 0px 15px 15px 0 rgba(34, 33, 81, 0.1);\n\t\t}\n\t}\n\n\t&.ghost {\n\t\t&.indicator {\n\t\t\topacity: 1;\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\t\t\tmargin-bottom: -1px;\n\n\t\t\t.TreeItem {\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: 0;\n\t\t\t\theight: 8px;\n\t\t\t\tborder-color: #2389ff;\n\t\t\t\tbackground-color: #56a1f8;\n\n\t\t\t\t&:before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: -8px;\n\t\t\t\t\ttop: -4px;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\twidth: 12px;\n\t\t\t\t\theight: 12px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tborder: 1px solid #2389ff;\n\t\t\t\t\tbackground-color: #ffffff;\n\t\t\t\t}\n\n\t\t\t\t> * {\n\t\t\t\t\t/* Items are hidden using height and opacity to retain focus */\n\t\t\t\t\topacity: 0;\n\t\t\t\t\theight: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&:not(.indicator) {\n\t\t\topacity: 0.5;\n\t\t}\n\n\t\t.TreeItem > * {\n\t\t\tbox-shadow: none;\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n}\n\n.TreeItem {\n\t--vertical-padding: 10px;\n\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: var(--vertical-padding) 10px;\n\tbackground-color: #fff;\n\tborder: 1px solid #dedede;\n\tcolor: #222;\n\tbox-sizing: border-box;\n}\n\n.Text {\n\tflex-grow: 1;\n\tpadding-left: 0.5rem;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n}\n\n.Count {\n\tposition: absolute;\n\ttop: -10px;\n\tright: -10px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 50%;\n\tbackground-color: #2389ff;\n\tfont-size: 0.8rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n}\n\n.disableInteraction {\n\tpointer-events: none;\n}\n\n.disableSelection,\n.clone {\n\t.Text,\n\t.Count {\n\t\tuser-select: none;\n\t\t-webkit-user-select: none;\n\t}\n}\n\n.Collapse {\n\tsvg {\n\t\ttransition: transform 250ms ease;\n\t}\n\n\t&.collapsed svg {\n\t\ttransform: rotate(-90deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrapper": `TreeItem_Wrapper__Zc9Z2`,
	"clone": `TreeItem_clone__hwBk-`,
	"TreeItem": `TreeItem_TreeItem__bBa8K`,
	"ghost": `TreeItem_ghost__dhwuH`,
	"indicator": `TreeItem_indicator__BlfgY`,
	"Text": `TreeItem_Text__ejgsU`,
	"Count": `TreeItem_Count__sHU5v`,
	"disableInteraction": `TreeItem_disableInteraction__0IK4x`,
	"disableSelection": `TreeItem_disableSelection__zicWc`,
	"Collapse": `TreeItem_Collapse__wXJRH`,
	"collapsed": `TreeItem_collapsed__K4TKF`
};
export default ___CSS_LOADER_EXPORT___;
